import React from 'react';
import Cookies from 'js-cookie';
import qs from 'qs';
import Prismic from 'prismic-javascript';
import {ENDPOINT} from "../config";

const PREVIEW_EXPIRES = 1/48; // 30 minutes

const linkResolver = function(doc){
  if (doc.type === 'article') return '/blog/' + doc.uid;
  if (doc.type === 'work') return '/work/' + doc.uid;
  return '/';
};

export default class Preview extends React.Component {

  componentDidMount() {
    const params = qs.parse(this.props.location.search.slice(1));
    Prismic.api(ENDPOINT).then(api => {
      api.previewSession(params.token, linkResolver, '/').then((url) => {
        Cookies.set(Prismic.previewCookie, params.token, { expires: PREVIEW_EXPIRES });
        this.props.history.push(url);
      });
    });
  }

  render() {
    return <p>Loading preview...</p>;
  }
}


// WEBPACK FOOTER //
// ./src/pages/Preview.js